import {
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  LOCALE_ID,
  EnvironmentProviders,
  Provider,
  inject,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors, withJsonpSupport, withXhr } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideServiceWorker } from '@angular/service-worker';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';

import { jwtInterceptor } from './core/interceptors/jwt.interceptor';
import { appRoutes } from './app.routes';
import { AccountService } from './core/services/account.service';

export function provideAppConfig(): (Provider | EnvironmentProviders)[] {
  return [
    provideZoneChangeDetection(),
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'SEK' },
    { provide: LOCALE_ID, useValue: 'sv-SE' },
    { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
    { provide: ErrorHandler, useClass: ApplicationinsightsAngularpluginErrorService },
    provideHttpClient(withXhr(), withInterceptors([jwtInterceptor]), withJsonpSupport()),
    provideAnimationsAsync(),
    provideRouter(appRoutes),
    provideAppInitializer(() => inject(AccountService).loadToken()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ];
}
